export const PORTAL_ROLES = {
  member: 'member',
  staff: 'staff',
  superadmin: 'superadmin'
};

export const PORTAL_NAV = [
  { to: '/bond-market', label: '债市行情', roles: ['staff', 'superadmin'] },
  {
    to: 'https://decision.oldox.online',
    label: '决策分析',
    roles: ['staff', 'superadmin'],
    external: true
  },
  { to: '/products', label: '产品列表', roles: ['staff', 'superadmin'] },
  { to: '/reports/product-performance', label: '新产品表现报告', roles: ['staff', 'superadmin'] },
  { to: '/reports/recent-product-performance', label: '近期产品表现报告', roles: ['staff', 'superadmin'] },
  { to: '/system-config', label: '小程序系统配置', roles: ['superadmin'] },
  { to: '/mp-access', label: '小程序身份', roles: ['superadmin'] },
  { to: '/auth-routing', label: '鉴权分流', roles: ['superadmin'] },
  { to: '/home-agency-tabs', label: '首页机构 Tab', roles: ['superadmin'] },
  { to: '/cache-meta', label: '列表缓存版本', roles: ['superadmin'] },
  { to: '/solicitations', label: '产品征集', roles: ['superadmin'] },
  { to: '/user-feedbacks', label: '用户反馈', roles: ['superadmin'] },
  { to: '/portal-users', label: '管理台用户', roles: ['superadmin'] }
];

export function defaultHomePath(portalRole) {
  return portalRole === 'staff' || portalRole === 'superadmin' ? '/products' : '/login';
}

export function navForRole(portalRole) {
  if (!portalRole) return [];
  return PORTAL_NAV.filter((item) => item.roles.includes(portalRole));
}

export function canAccessRoute(pathname, portalRole) {
  const item = PORTAL_NAV.find((nav) => pathname === nav.to || pathname.startsWith(`${nav.to}/`));
  if (!item) {
    if (pathname.startsWith('/product/')) {
      return navForRole(portalRole).some((nav) => nav.to === '/products');
    }
    return true;
  }
  return item.roles.includes(portalRole);
}

export const PORTAL_ROLE_LABEL = {
  member: '会员',
  staff: '运维',
  superadmin: '超级管理员'
};
